// @flow
import React, { type Node, useContext, useEffect } from 'react';

import BannersContext from './banners-context';
import Banner from './banner';
import { places } from './places';


type Props = {
  children?: Node,
  placeId: string,
  className?: string,
  leaveContainerOnEmpty?: boolean,
  displayAsPlaceholder?: boolean,
  width?: number,
  height?: number,
  refreshOnMount?: boolean,
}

const BannerContent = ({
  children,
  placeId,
  className,
  leaveContainerOnEmpty,
  displayAsPlaceholder,
  width: widthReplace,
  height: heightReplace,
  refreshOnMount,
}: Props) => {
  const { width = 0, height = 0 } = places[placeId] || {};
  const style = displayAsPlaceholder ? {
    width: widthReplace || widthReplace === 0 ? widthReplace : width,
    height: heightReplace || heightReplace === 0 ? heightReplace : height,
  } : {};


  const {
    data: { getBannerDataByPlaceId },
    effects: {
      refreshBannerByPlaceId,
    },
  } = useContext(BannersContext);

  const {
    loading: bannerLoading = false,
    bannerUrl = '',
  } = getBannerDataByPlaceId(placeId) || {};


  useEffect(() => {
    if (refreshOnMount) {
      refreshBannerByPlaceId(placeId);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  if ((!bannerUrl && bannerLoading) || (!bannerUrl && !leaveContainerOnEmpty)) {
    return null;
  }


  return (
    <div className={className}>
      {displayAsPlaceholder && <div style={style} />}
      {!displayAsPlaceholder
        && bannerUrl
        && <Banner placeId={placeId} skipRefresh />}
      {children}
    </div>
  );
};

export default BannerContent;
